import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import client, { apiCall } from '../../api/client';
import CopyButton from '../../components/CopyButton';
import Loader from '../../components/Loader';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3030/api';

export default function Endpoints() {
  const [networks, setNetworks] = useState([]);
  const [apiKey, setApiKey] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      apiCall(client.get('/network/get_list')),
      apiCall(client.get('/api_key/get_list')),
    ]).then(([networkList, keys]) => {
      setNetworks(networkList);
      const active = keys.find((k) => k.status === 'ACTIVE');
      setApiKey(active ? active.uniqueId : '');
    }).catch((e) => setError(e.message)).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <h1>RPC Endpoints</h1>
      {error && <div className="form-error">{error}</div>}
      {loading ? (
        <div className="card"><Loader label="Loading endpoints..." /></div>
      ) : (
        <>
          {!apiKey && (
            <div className="card" style={{ marginBottom: 24 }}>
              <p>You need an API key before you can use these endpoints.</p>
              <Link to="/dashboard/api-keys" className="btn btn-primary">Create an API key</Link>
            </div>
          )}
          <div className="card">
            <p className="form-hint" style={{ marginBottom: 16 }}>
              Drop the endpoint for a network straight into ethers.js, web3.js, or viem as your RPC URL.
            </p>
            {networks.map((n) => {
              const url = `${API_BASE}/rpc/${n.slug}/${apiKey || '<YOUR_API_KEY>'}`;
              return (
                <div key={n.uniqueId} style={{ marginBottom: 16 }}>
                  <div style={{ fontWeight: 600, marginBottom: 6 }}>{n.name}</div>
                  <div className="key-row">
                    <span>{url}</span>
                    <CopyButton text={url} />
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
